import {XauditModel} from '../xaudit.model';
import {NoteCategoryDataModel} from './note-category-data.model';
import {NoteTypeDataModel} from './note-type-data.model';
import {TdoUserConfigurationModel} from '../configuration/user/tdo-user-configuration.model';

export class NoteDataModel extends XauditModel {
  NoteId: string;
  Note: string;
  isLocked: boolean = false;
  dataNoteCategories: NoteCategoryDataModel[] = [];
  dataNoteTypes: NoteTypeDataModel[] = [];
  xauditCreatedByUser: TdoUserConfigurationModel;
  xauditModifiedByUser: TdoUserConfigurationModel;
}
